<div class="spinner-overlay">
  <div class="dialog" tabindex="-1">
    <div class="spinner-wrapper">
      <div class="bot-loader-wrapper">
        <span class="ai-diamond"></span>
        <span class="bot-loader"> </span>
      </div>
    </div>
    <div class="message">
      <span>{{ loaderMessage }}</span>
    </div>
  </div>
</div>
